import Joi from 'joi';

export default function validator(test, keys) {
  const schema = Joi.object().keys(keys);
  return schema.validate(test);
}
